// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"b8281051","206":"1fb2fc47","286":"fce8f1d2","435":"34e5c41a","452":"de4b815d"}[chunkId] + ".chunk.css";
};